<template>
  <div class="life"
       id="lifetop">
    <En_topper></En_topper>
    <div class="nei_tit">
      <img src="../assets/life_tit.jpg"
           alt="">
      <span>Quality Life</span>
    </div>
    <!-- 业务介绍 -->
    <div class="nei_jieshao"
         style="height:21rem;">
      <h2>Business Introduction</h2>
      <p>Ennova Life is a division of the ENN Group focused on improving the quality of life. Driven by consumers’ aspirations for a better life and aiming to meet families’ needs for a high-quality life, Ennova concentrates on two core living scenarios: “Home” and “Travel”. It introduces an innovative product and service system for a high-quality life with health at the core, and develops the “Smart Home” and “Smart Travel” intelligent platforms for a smart and high-quality life. By connecting and empowering the ecosystem of the quality life industry, Ennova Life is committed to becoming a smart operator of quality life in the new era, allowing customers to access high-quality, healthy lifestyles.<br />
        Currently, Ennova Life operates in Hebei, Guangxi, Xizang, Shandong, and other regions. In 2024, it served over 155,000 households with Smart Home and more than 12.34 million visitors through Smart Travel while partnering with over 1,000 entities within its ecosystem.</p>
      <dl>
        <dt>Serving with Smart Home</dt>
        <dd>155,000<i><sup>+</sup>households</i></dd>
      </dl>
      <dl>
        <dt>Serving visitors with Smart Travel</dt>
        <dd>12.34<i>million<sup>+</sup></i></dd>
      </dl>
      <dl>
        <dt>Partnering with</dt>
        <dd>1,000<i><sup>+</sup>entities</i></dd>
      </dl>
      <a href="http://www.ennovalife.com"
         class="viewmore">VIEW MORE</a>
    </div>

    <!-- 健康家服务 -->
    <div class="jkjfw"
         style="height:8rem;">
      <h2><i class="jkjfw_icon"></i>Smart Home Services</h2>
      <div class="life_info_sub">
        <li><i class="znjfwa"></i>Focusing on home scenarios, with services that transcend time and space boundaries</li>
        <li><i class="znjfwb"></i>Smartly connecting users, communities, and ecosystem resources</li>
        <li><i class="znjfwc"></i>Delivering premium life services across living, diet, exercise, entertainment, treatment, health preservation, and purchase</li>
        <li><i class="znjfwd"></i>An integrated system of smart and healthy home products and services</li>
      </div>
    </div>
    <div class="lkj">
      LAIKANG SMART LAND
    </div>
    <div class="life_wrapper">
      <p>
        LAIKANG SMART LAND is a premier health-focused community brand developed by Ennova. Drawing on over 30 years of expertise, it incorporates health principles and smart technology into community environments, architecture, facilities, and operational services, creating themed products centered around health, selecting ecological resources, and building a product and service system for a smart and healthy life. Tailored to regional advantages and characteristics, LAIKANG SMART LAND has established over 20 projects with different themes nationwide, including urban, rural, coastal, and art and cultural themes. These projects provide high-quality, intelligent health services to improve the quality of life for homeowners.
      </p>
      <ul>
        <li><img src="../assets/tywqlkj.jpg"
               alt="">Rural Hot Springs - LAIKANG LAND</li>
        <li><img src="../assets/bhdjlkj.jpg"
               alt="">Coastal Retreat - LAIKANG LAND</li>
        <li><img src="../assets/gefydlkj.jpg"
               alt="">Golf - LAIKANG LAND</li>
        <li><img src="../assets/dsshlkj.jpg"
               alt="">Urban Living - LAIKANG LAND</li>
      </ul>
      <a href="https://ennovalife.com/znjsh"
         class="viewmore">VIEW MORE</a>
    </div>

    <!-- <div class="lkw">
      LAIKANG.com<a href="https://www.laikang.com/">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>
    <div class="life_wrapper"
         style="padding-top:0.2rem">
      <p>
        LAIKANG.com is an Health Capability Cognitive Platform that focuses on the “Healthy Home” scenario. Grounded in the San Ji Yi Shang Treatment System (Three Treatments for Inhibiting Entropy), it deepens the understanding of health capabilities and designs intelligent lifestyles. LAIKANG.com collects real-time health data through intelligent IoT. With reliance on industrial practices and expert models, it continuously trains a health model. With life entropy and intelligent simulation as its core, the platform unifies the language of health capabilities and precisely matches demands with supply to enhance industry-wide capabilities through an intelligent demand-supply model!
      </p>
    </div> -->

    <!-- 健康游服务 -->
    <div class="jkyfw"
         style="height:8.6rem;">
      <h2><i class="jkyfw_icon"></i>Smart Travel Services</h2>
      <div class="life_info_sub">
        <li><i class="znyfwa"></i>Creating a smart travel lifestyle with a focus on tourism scenarios</li>
        <li><i class="znyfwb"></i>Smartly connecting travelers, merchants, scenic spots, and other tourism elements</li>
        <li><i class="znyfwc"></i>Accurately identifying travel needs and delivering personalized itineraries, real-time interactions, and other services across the entire journey</li>
        <li><i class="znyfwd"></i>Providing diverse lifestyle experiences and managing key components of the tourism ecosystem</li>
      </div>
    </div>
    <div class="kllyg">
      Smart Theme Parks
    </div>
    <div class="life_wrapper">
      <p>
        Smart theme parks are unique travel destinations developed by Ennova by leveraging resources such as mountains, oceans, and cultural heritage, including island resorts, high-altitude experiences, cultural attractions, and mountain retreats, which are located in Guangxi, Xizang, Hebei, Shandong, and other provinces. The smart theme parks currently under construction and in operation include the Dream Langfang Smart Theme Park, Nyingchi Smart Theme Park, and Beihai Smart Theme Park.
      </p>
      <ul>
        <li><img src="../assets/mlflyzng.jpg"
               alt="">Dream Langfang Smart Theme Park</li>
        <li><img src="../assets/lzlyzng.jpg"
               alt="">Nyingchi Smart Theme Park</li>
        <li><img src="../assets/bhlyzng.jpg"
               alt="">Beihai Smart Theme Park</li>
      </ul>
      <a href="https://ennovalife.com/znysh"
         class="viewmore">VIEW MORE</a>
    </div>
    <div class="enaowa">
      ENOWA
    </div>
    <div class="life_wrapper"
         style="padding-top:0.2rem">
      <p>
        ENOWA is an intelligent platform under Ennova Life focused on tourism scenarios. From a “capability” perspective, it reconstructs the tourism value chain. With an emphasis on building a new industry model based on intelligent demand-supply alignment, the platform offers precisely tailored, personalized experiences for travelers while empowering businesses and destination operators with an end-to-end system for smart customer acquisition, on-demand services, and efficient operations, thereby redefining the smart travel lifestyle where “imagination becomes reality”.
        <br />
        <a href="https://www.enowa.cn/"
           class="viewmore">VIEW MORE</a>
      </p>
    </div>

    <!-- 健康服务 -->
    <!-- Swiper -->
    <div class="swiper-containera">
      <div class="jkfw_info">
        <h2><i class="jkfw_icon"></i>Health Service</h2>
        <p>Ennova has been deeply involved in the health sector for many years. Leveraging life and health theories and the San Ji Yi Shang Treatment System (Three Treatments for Inhibiting Entropy), it develops clusters in health preservation, wellness, medicine, nursing, and insurance. By integrating home health services and smart technology into healthy living, chronic disease management, medical care, elder care, and health insurance, Ennova drives industry upgrades, implements best practices, and enhances quality of life with its intelligent capacity.
          <a href="https://ennovalife.com/jkfw"
             class="viewmoreb">VIEW MORE</a>
        </p>

        <div class="lifehealth_sub">
          <ul>
            <li><a href="http://ennovalife.com/jksh"
                 target="_blank"
                 class="mytrans radius50">Seven-Cultivation Life</a></li>
            <li><a href="http://ennovalife.com/mbgl"
                 target="_blank"
                 class="mytrans radius50">Chronic Disease Management</a></li>
            <li><a href="http://ennovalife.com/zzyy"
                 target="_blank"
                 class="mytrans radius50">Elder Care</a></li>
            <li><a href="http://ennovalife.com/jkbx"
                 target="_blank"
                 class="mytrans radius50">Health Insurance</a></li>
          </ul>
        </div>
      </div>

    </div>
    <!-- Swiper -->

    <div class="lkw">
      LAIKANG Technology<a href="http://ennovalife.com/eow_03280956_225">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>
    <div class="life_wrapper"
         style="padding-top:0.2rem">
      <p>
        Guided by its mission to “reduce the burden of illness worldwide”, LAIKANG Technology is rooted in the San Ji Yi Shang Treatment (Three Treatments for Inhibiting Entropy) theory. It is committed to building intelligent healthcare capacity, encouraging healthier lifestyles, and upgrading coordination across the health industry.<br />

        Centered on household health needs, LAIKANG Technology integrates intelligent health companion products into domestic life, tracking the physical, mental, and emotional health of every family member, offering them one-stop, personalized healthcare services, and thereby safeguarding their health.<br />

        By leveraging life entropy and intelligent simulation, the platform develops intelligent healthcare models, standardizes the language across health capabilities, and facilitates seamless communication between demand and supply, thereby advancing the intelligent upgrade of the healthcare industry through an intelligent demand-supply alignment model!
      </p>
    </div>
    <En_footer></En_footer>
  </div>
</template>

<script>
import Swiper from "swiper";
import En_topper from "./En_topper";
import En_footer from "./En_footer";
export default {
  components: {
    En_topper, En_footer
  },
  name: "En_life",
  data () {
    return {
    };
  },

  mounted () {

    new Swiper(".swiper-containera", {
      loop: true,
      // 如果需要分页器
      //   grabCursor: true,
      //   centeredSlides: true,
      //   slidesPerView: "auto",
      autoplay: false,
      allowTouchMove: true,
      autoplayDisableOnInteraction: false,//用户操作后是否自动播放
      //   parallax: true,//允许延迟
      pagination: '.swiper-pagination',
      paginationClickable: true,
      paginationBulletRender: function (swiper, index, className) {
        var Territory = document.querySelectorAll('.Territory')[index + 1].getAttribute('data-Territory');
        return '<div class="' + className + '">' + Territory + '</div>';
      }
    });

    let maodian = this.$route.params.maodian;
    console.log(maodian);
    if (maodian) {
      const targetElement = document.querySelector(maodian);
      window.scrollTo({ top: targetElement.offsetTop, behavior: 'smooth' });
    } else {
      window.scrollTo(0, 0);
    }
  },
  methods: {
    // goToUrl () {
    //   window.location.href = "https://www.laikangyundong.com";
    // }
  }
};
</script>

<style scoped>
.life {
  background: #fff;
  width: 750px;
  height: auto;
  overflow: hidden;
}
.nei_tit {
  width: 750px;
  height: 450px;
  position: relative;
  margin-top: 95px;
}
.nei_tit img {
  width: 750px;
  height: 450px;
  position: absolute;
  left: 0;
  top: 0;
}
.nei_tit span {
  position: absolute;
  left: 40px;
  top: 200px;
  font-size: 48px;
  color: #fff;
  font-weight: 500;
}
h2 {
  font-size: 36px;
  color: #1d2129;
  display: block;
  padding: 60px 40px 30px 40px;
  width: 670px;
  text-align: left;
  float: left;
}
p {
  font-size: 28px;
  color: #323233;
  width: 670px;
  text-align: left;
  padding: 10px 40px;
  float: left;
  line-height: 150%;
}
.nei_jieshao {
  width: 750px;
  height: 680px;
  background: url(../assets/introduce_bg.jpg);
  background-size: 100% 100%;
  float: left;
}
.nei_jieshao dl {
  margin-top: 30px;
  width: 275px;
  height: 170px;
  margin-right: 20px;
  float: left;
  padding-left: 40px;
}
.nei_jieshao dl dt {
  font-size: 28px;
  color: #323233;
  text-align: left;
}
.nei_jieshao dl dd {
  font-size: 44px;
  color: #013b78;
  text-align: left;
  margin-top: 10px;
}
.nei_jieshao dl dd i {
  font-size: 30px;
  font-weight: 600;
  font-style: normal;
}

.jkjfw {
  width: 750px;
  height: 535px;
  float: left;
  background: url(../assets/health_bg.jpg);
  background-size: 100% 100%;
}
.jkjfw .jkjfw_icon {
  width: 80px;
  height: 80px;
  background: url(../assets/jkjfw_icon.png);
  background-size: 100% 100%;
  float: left;
  margin-right: 30px;
}
.jkjfw h2 {
  color: #fff;
  line-height: 80px;
  padding-bottom: 10px;
}
.jkjfw p {
  color: #fff;
}
.lkj {
  width: 670px;
  height: 200px;
  float: left;
  background: url(../assets/lkj.jpg);
  background-size: 100% 100%;
  font-size: 36px;
  color: #fff;
  padding: 40px;
  text-align: left;
  font-weight: 600;
  line-height: 200px;
}
.life_wrapper {
  width: 750px;
  height: auto;
  float: left;
  padding: 50px 0px;
}
.life_wrapper ul {
  width: 690px;
  padding: 20px 30px;
  float: left;
}
.life_wrapper ul li {
  width: 230px;
  text-align: center;
  font-size: 26px;
  float: left;
}
.life_wrapper ul li img {
  width: 210px;
  height: 210px;
}
.viewmore {
  width: 50%;
  display: block;
  height: 55px;
  border: 1px solid #ddd;
  text-align: center;
  font-size: 0.35rem;
  line-height: 55px;
  float: left;
  margin-left: 25%;
  margin-top: 50px;
  background: #fff;
  color: #666;
}
.viewmoreb {
  width: 50%;
  display: block;
  height: 55px;
  border: 1px solid #fff;
  text-align: center;
  font-size: 0.35rem;
  line-height: 55px;
  float: left;
  margin-left: 25%;
  margin-top: 50px;
  color: #fff;
}
.lkw {
  width: 670px;
  height: 250px;
  float: left;
  background: url(../assets/en_lkw.jpg);
  background-size: 100% 100%;
  font-size: 36px;
  color: #fff;
  padding: 40px;
  text-align: left;
  font-weight: 600;
  line-height: 200px;
  margin-top: 20px;
  position: relative;
}
.arrow_btn {
  width: 100px;
  height: 60px;
  float: left;
  background: url(../assets/arrow_white.png) left center no-repeat;
  background-size: 34px 27px;
  position: absolute;
  left: 650px;
  top: 110px;
}
.jkyfw {
  width: 750px;
  height: 535px;
  float: left;
  background: url(../assets/travle_bg.jpg);
  background-size: 100% 100%;
}
.life_info_sub {
  width: 700px;
  padding: 25px;
  float: left;
}
.life_info_sub li {
  width: 349px;
  height: 160px;
  float: left;
  text-align: center;
  font-size: 24px;
  color: #fff;
}
.life_info_sub li i {
  display: block;
  width: 60px;
  height: 60px;
  margin: 10px auto;
}
.life_info_sub li i.znjfwa {
  background: url(http://www.lffeiyasi.com/images/icons.png) 0 -540px;
  background-size: 1200px 1200px;
}
.life_info_sub li i.znjfwb {
  background: url(http://www.lffeiyasi.com/images/icons.png) -60px -540px;
  background-size: 1200px 1200px;
}
.life_info_sub li i.znjfwc {
  background: url(http://www.lffeiyasi.com/images/icons.png) -120px -540px;
  background-size: 1200px 1200px;
}
.life_info_sub li i.znjfwd {
  background: url(http://www.lffeiyasi.com/images/icons.png) -180px -540px;
  background-size: 1200px 1200px;
}
.life_info_sub li i.znyfwa {
  background: url(http://www.lffeiyasi.com/images/icons.png) -240px -540px;
  background-size: 1200px 1200px;
}
.life_info_sub li i.znyfwb {
  background: url(http://www.lffeiyasi.com/images/icons.png) -300px -540px;
  background-size: 1200px 1200px;
}
.life_info_sub li i.znyfwc {
  background: url(http://www.lffeiyasi.com/images/icons.png) -360px -540px;
  background-size: 1200px 1200px;
}
.life_info_sub li i.znyfwd {
  background: url(http://www.lffeiyasi.com/images/icons.png) -420px -540px;
  background-size: 1200px 1200px;
}
.jkyfw .jkyfw_icon {
  width: 80px;
  height: 80px;
  background: url(../assets/jkyfw_icon.png);
  background-size: 100% 100%;
  float: left;
  margin-right: 30px;
}
.jkyfw h2 {
  color: #fff;
  line-height: 80px;
  padding-bottom: 10px;
}
.jkyfw p {
  color: #fff;
}
.kllyg {
  width: 670px;
  height: 200px;
  float: left;
  background: url(../assets/klly.jpg);
  background-size: 100% 100%;
  font-size: 36px;
  color: #fff;
  padding: 40px;
  text-align: left;
  font-weight: 600;
  line-height: 200px;
  position: relative;
}
.enaowa {
  width: 670px;
  height: 250px;
  float: left;
  background: url(../assets/en_enaowaa.jpg);
  background-size: 100% 100%;
  font-size: 36px;
  color: #fff;
  padding: 40px;
  text-align: left;
  font-weight: 600;
  line-height: 200px;
  position: relative;
}

.swiper-containera {
  width: 750px;
  height: 900px;
  float: left;
  position: relative;
  background: url(../assets/jksh.jpg);
  background-size: 100% 100%;
}
.lifehealth_sub {
  width: 700px;
  height: auto;
  overflow: hidden;
  padding: 25px;
  position: absolute;
  left: 0;
  top: 650px;
}
.lifehealth_sub li {
  width: 155px;
  height: 155px;
  float: left;
  padding: 10px;
}
.lifehealth_sub li a {
  display: block;
  width: 155px;
  height: 155px;
  background: #fff;
  text-align: center;
  font-size: 26px;
  line-height: 28px;
  font-weight: bold;
  color: #013b78;
  border-radius: 50%;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;
}
.swiper-containera .swiper-wrapper {
  width: 750px;
  height: 1038px;
  position: relative;
}
.jkfw_info {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 100;
}
.jkfw_info h2 {
  color: #fff;
  line-height: 80px;
  position: absolute;
  left: 10px;
  top: 0px;
  z-index: 20;
}
.jkfw_info h2 i.jkfw_icon {
  width: 80px;
  height: 80px;
  background: url(../assets/jkfw_icon.png);
  background-size: 100% 100%;
  float: left;
  margin-right: 30px;
}
.jkfw_info p {
  color: #fff;
  position: absolute;
  left: 10px;
  top: 160px;
  z-index: 20;
  padding-right: 20px;
  line-height: 110%;
}
.swiper-containera .swiper-slide {
  width: 750px;
  height: 1038px;
  position: relative;
}
.swiper-containera .swiper-slide h2 {
  color: #fff;
  line-height: 80px;
  position: absolute;
  left: 10px;
  top: 0px;
  z-index: 20;
}
.swiper-containera .swiper-slide h2 i.jkfw_icon {
  width: 80px;
  height: 80px;
  background: url(../assets/jkfw_icon.png);
  background-size: 100% 100%;
  float: left;
  margin-right: 30px;
}
.swiper-containera .swiper-slide p {
  color: #fff;
  position: absolute;
  left: 10px;
  top: 160px;
  z-index: 20;
  padding-right: 20px;
}
.swiper-containera .swiper-slide img {
  width: 750px;
  height: 1038px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}
</style>
<style>
.swiper-containera .swiper-pagination-bullet {
  width: 20%;
  float: left;
  height: 100px;
  margin: 0;
  border-top: 1px solid #fff;
  background: none;
  border-radius: 0;
  font-size: 25px;
  color: #fff;
  /* line-height: 100px; */
  line-height: 120%;
  opacity: 0.7;
  display: flex;
  align-items: center;
  justify-content: center;
}
.swiper-containera .swiper-pagination-bullet-active {
  background: #fff;
  color: #013b78;
  border-top: 5px solid #6eba2c;
  opacity: 1;
}
.swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0;
}
.swiper-container-horizontal > .swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  bottom: 300px;
}
</style>
